import { render, staticRenderFns } from "./PreloaderSVGmiddle.vue?vue&type=template&id=d12ae692&"
import script from "./PreloaderSVGmiddle.vue?vue&type=script&lang=js&"
export * from "./PreloaderSVGmiddle.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderSVGmiddle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports